<template>
  <div class="doubele-eleven ">
    <img class="top-img" src="https://o.666visa.cn/static/ssqpeer/activity/double-twelve/double-twelve-1.png" alt="">
    <div class="container-md">
      <div class="coupon-box">
        <div class="coupon-title">签证手速王 限量整点抢券</div>
        <div class="receive-time">每日11:00限量开抢</div>
        <div class="coupon-list-box">
            <div class="coupon-list">
            <div class="coupon-item" v-for="coupon in showCouponList" :key="coupon.code" :class="{disabled: !isBeforeTimeRange && (isAfterTimeRange || coupon.computed_status === 2) }">
              <div class="coupon-top">
                <template>
                  <div class="coupon-country" v-if="coupon.visa_country.length === 1">{{coupon.visa_country[0].country}}优惠券</div>
                  <div class="coupon-country-box" v-else></div>
                </template>
                <div class="price-box">
                  <span class="currency">￥</span><span class="num">{{ coupon.cash_reduce / 100 }}</span>
                </div>
                <div class="coupon-dec">
                  <div class="goods-category" v-if="coupon.scope === 0 && coupon.exclusion_scope === 0">全品类</div>
                  <div class="max-price" v-if="coupon.reach_reduce">满{{ coupon.reach_reduce / 100 }}元可用</div>
                  <div class="max-price" v-else>无门槛</div>
                </div>
              </div>
              <div class="coupon-bottom">
                <div class="before-receive" v-if="isBeforeTimeRange">11:00开抢</div>
                <div class="disabled-receive" v-else-if="isAfterTimeRange || coupon.computed_status === 2">今日已抢完</div>
                <div class="allow-receive" v-else-if="coupon.computed_status === 0" @click="receiveCoupon(coupon)">立即抢</div>
                <div class="received" v-else-if="coupon.computed_status === 1">已领取</div>
              </div>
            </div>
          </div>
          <div class="tips">注：特价商品不支持使用优惠券  优惠券有效期截止2023.12.31</div>
        </div>
      </div>

      <div class="product-box">
        <div class="product-title">热门国家集合 出签顺畅</div>
        <div class="product-list">
          <product-item v-for="item in hotProduct" :key="item.visa_product_id" :product="item"></product-item>
        </div>
      </div>

      <img class="invite-register" src="https://o.666visa.cn/static/ssqpeer/activity/double-twelve/double-twelve-4.png" alt="">

      <div class="rule-box">
        <div class="rule-title">活动规则</div>
        <div class="rule-list">
          <div class="rule-item">
            <div class="item-title">活动时间</div>
            <div class="item-content">整点抢券活动时间：12月05日-12月22日，每天11:00开抢</div>
          </div>
          <div class="rule-item">
            <div class="item-title">参与方式</div>
            <div class="item-content">登录上上签官网或小程序，进入指定活动页面即可参与指定活动</div>
          </div>
          <div class="rule-item">
            <div class="item-title">优惠券领取规则</div>
            <div class="item-content">同一用户同类型优惠券每日只能领取一张，不能重复领取。<span class="emphasis">（同一用户定位：同一个上上签ID、ip、手机机号、设备号）</span></div>
          </div>
          <div class="rule-item">
            <div class="item-title">优惠券使用规则</div>
            <div class="item-content">优惠券使用有效期是自领取时间至12月31日，特价商品不支持使用优惠券，特定国家优惠券仅限活动商品使用</div>
          </div>
        </div>
      </div>

      <div class="interpretation">该活动最终解释权归我司所有</div>
    </div>

  </div>
  </template>

  <script>
  import { Loading } from 'element-ui';
  import { mapMutations } from 'vuex';
  import moment from 'moment';
  import sensorsdata from 'sa-sdk-javascript';
  import ProductItem from './components/product-item.vue';
  import User from '../../../libs/user';
  import utils from '../../../libs/utils';
  import Http from '../../../libs/http';


  // 双十一活动
  export default {
    name: '',
    components: {
      ProductItem,
    },
    data() {
      return {
        nowTime: 0, // 当前时间戳
        timer: null,
        couponList: [],
        counponStatus: [], // 优惠券状态，当前是否被领取
        hotProduct: [],
        delayProduct: [],
        timeRange: {
          start: {
            date: '2023-12-05',
            time: '11:00',
          },
          end: {
            date: '2023-12-22',
            time: '11:30',
          },
        },
      };
    },
    computed: {
      showCouponList() {
        const sortCouponList = JSON.parse(JSON.stringify(this.couponList)).sort((a, b) => a.id - b.id);
        return sortCouponList.map((item) => {
          const statusItem = this.counponStatus.find(x => x.coupon_id === item.id);
          // 0 可领取  1：已领取 2: 领取完
          let computed_status = 0;
          if (item.remaining_num === 0 || (statusItem && statusItem.status === 2)) {
            computed_status = 2;
          } else if (statusItem && statusItem.status === 1) {
            computed_status = 1;
          }
          return {
            ...item,
            // 0已领取
            computed_status,
          };
        });
      },
      nowDate() {
        return moment(this.nowTime).utcOffset(8).format('YYYY-MM-DD');
      },
      nowHourMinute() {
        return moment(this.nowTime).utcOffset(8).format('HH:mm');
      },
      isBeforeTimeRange() {
        return this.nowDate < this.timeRange.start.date || (this.nowDate <= this.timeRange.end.date && this.nowHourMinute < this.timeRange.start.time);
      },
      isAfterTimeRange() {
        return this.nowDate > this.timeRange.end.date || (this.nowDate >= this.timeRange.start.date && this.nowHourMinute > this.timeRange.end.time);
      },
    },
    watch: {},
    created() {
      sensorsdata.track('ActivityPageView', {
        peer_name: User.peer.peer_name,
        visa_peer_id: User.peer.visa_peer_id,
        activity_name: '2023-1212',
      });

      this.initNowTime();
      this.getProduct();
      this.getCouponList();
      if (User.isLogin()) {
        this.getCouponStatusList();
      }
    },
    destroyed() {
      clearInterval(this.timer);
    },
    methods: {
      ...mapMutations(['SHOW_LOGIN_BOX']),
      initNowTime() {
        this.nowTime = new Date().getTime();
        this.timer = setInterval(() => {
          this.nowTime = new Date().getTime();
        }, 1000);
      },
      getProduct() {
        Http.post('/sys/festival_product_query', {}).then((res) => {
          this.hotProduct = res.hot_product;
          this.delayProduct = res.delay_product;
        });
      },
      getCouponList() {
        Http.post('/sys/festival_coupon_get', {}).then((res) => {
          this.couponList = res.list;
        });
      },
      getCouponStatusList() {
        Http.post('/festival_peer_coupon_get', {}).then((res) => {
          this.counponStatus = res.result;
        });
      },
      // 领取优惠券
      receiveCoupon(coupon) {
        // 未登录跳转到登录
        if (!User.isLogin()) {
          this.SHOW_LOGIN_BOX({ from: 'activity_double_eleven' });
          return;
        }
        const loadingInstance = Loading.service({
          text: '领取中',
        });
        Http.post('/festival_coupon_excharge', {
          id: coupon.id,
        }).then(() => {
          loadingInstance.close();
          utils.msg.success('领取成功');
          this.getCouponStatusList();
        }).catch((e) => {
          console.log(e);
          loadingInstance.close();
          this.getCouponStatusList();
          this.getCouponList();
        });
      },
    },
  };
  </script>

  <style scoped lang="less">
  .doubele-eleven{
    background: #3793FF;
    line-height: 1;
    font-size: 0;
    .container-md{
      width: 1000px;
    }
    .top-img{
      width: 100%;
      height: auto;
    }
    .coupon-box{
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 0 20px 0;
      // background: linear-gradient(180deg, #14165F 0%, #282B91 100%);
      border-radius: 8px;
      .coupon-title{
        width: 518px;
        height: 90px;
        text-indent: 14px;
        text-align: center;
        line-height: 86px;
        color: #FFFFFF;
        font-size: 34px;
        background: url(https://o.666visa.cn/static/ssqpeer/activity/double-twelve/double-twelve-2.png) no-repeat center / 100% 100%;
      }
      .receive-time{
        margin-top: 20px;
        color: #fff;
        font-size: 24px;
      }
      .coupon-list-box{
        width: 100%;
        margin-top: 22px;
        padding: 40px 28px 20px 28px;
       .coupon-list{
          display: flex;
          align-items: center;
          width: 100%;
          flex-wrap: wrap;
        }
        .coupon-item{
          width: 220px;
          height: 268px;
          background: url(https://o.666visa.cn/static/ssqpeer/activity/eleven/coupon-effect.png) no-repeat center / 100% 100%;
          margin-bottom: 20px;
          margin-right: 20px;
          display: flex;
          align-items: center;
          flex-direction: column;
          color: #fff;
          &:nth-child(4n){
            margin-right: 0;
          }
          &.disabled{
            background: url(https://o.666visa.cn/static/ssqpeer/activity/eleven/coupon-lose.png) no-repeat center / 100% 100%;
            .price-box,.max-price{
              color: rgba(255, 33, 57, 0.6);
            }
            .goods-category{
              color: rgba(145, 89, 71, 0.6);
            }
            .coupon-bottom{
              .before-receive, .disabled-receive{
                color: rgba(90, 54, 43, 0.6);
              }
              .allow-receive, .received{
                color: rgba(255,255,255,0.5);
                background:rgba(255, 33, 57, 0.5)
              }
            }
            .coupon-country{
              color: rgba(145, 89, 71, 0.6);
              background: rgba(255, 223, 185, 0.6);
            }
          }
          .coupon-country{
            color: #915947;
            font-size: 20px;
            padding: 4px 10px;
            line-height: 28px;
            background: #FFDFB9;
            border-radius: 0px 0px 16px 16px;
          }
          .coupon-country-box{
            height: 36px;
          }
          .price-box{
            margin-top: 24px;
            display: flex;
            align-items: center;
            color: #FF2139;
            justify-content: center;
            .currency{
              font-size: 32px;
              font-weight: 600;
              margin-top: 30px;
            }
            .num{
              font-size: 80px;
              font-weight: 600;
              margin-left: -4px;
            }
          }
          .coupon-dec{
            display: flex;
            margin-top: 12px;
            justify-content: center;
            white-space: nowrap;
          }
          .goods-category{
            color: #915947;
            font-size: 22px;
          }
          .max-price{
            font-size: 22px;
            color: #FF2139;
          }
          .coupon-top{
            flex: 1;
          }
          .coupon-bottom{
            height: 70px;
            display: flex;
            justify-content: center;
            align-items: center;
            .before-receive, .disabled-receive{
              font-size: 24px;
              line-height: 32px;
              color: #5A362B;
            }
            .allow-receive, .received{
              width: 136px;
              height: 45px;
              background: #FF2139;
              border-radius: 23px;
              font-size: 24px;
              font-weight: 500;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              color: #fff;
            }
            .received{
              cursor: default;
              opacity: 0.5;
            }

          }
        }
        .tips{
          color: rgba(255,255,255,0.5);
          font-size: 20px;
          text-align: center;
        }
      }
    }

    .product-box{
      margin: 20px 0px 10px 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .product-title{
        width: 518px;
        height: 90px;
        text-indent: 14px;
        text-align: center;
        line-height: 86px;
        color: #FFFFFF;
        font-size: 34px;
        background: url(https://o.666visa.cn/static/ssqpeer/activity/double-twelve/double-twelve-2.png) no-repeat center / 100% 100%;
      }
      .product-list{
        width: 100%;
        margin-top: 32px;
        display: flex;
        flex-wrap: wrap;
        .product-item{
          margin-bottom: 30px;
          margin-right: 29px;
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }

    .invite-register{
      width: 100%;
    }

    .rule-box{
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 8px;
      margin: 16px 60px 0 60px;
      .rule-title{
        width: 366px;
        height: 129px;
        margin-bottom: 16px;
        text-align: center;
        line-height: 121px;
        color: #FFFFFF;
        font-size: 34px;
        background: url(https://o.666visa.cn/static/ssqpeer/activity/double-twelve/double-twelve-3.png) no-repeat center / 100% 100%;
      }
      .rule-list{
        padding: 40px;
        background-color: #fff;
        border-radius: 16px;
        .rule-item{
          margin-bottom: 20px;
          &:last-child{
            margin-bottom: 0;
          }
          .item-title{
            display: inline-block;
            padding: 10px 12px;
            background: #fff;
            color: #5A362B;
            font-size: 22px;
            border-radius: 24px;
            font-weight: bold;
          }
          .item-content{
            padding-left: 12px;
            margin-top: 12px;
            color: #5A362B;
            font-size: 20px;
            line-height: 32px;
            white-space: pre-wrap;
            .emphasis{
              color: #FF263D;
            }
          }

        }
      }

    }

    .interpretation{
      padding: 40px 0;
      color: #fff;
      font-size: 20px;
      text-align: center;
    }
  }
  </style>



// WEBPACK FOOTER //
// src/pages/activity/festival/index.vue